type TCrmRuntimeConfig = {
  companyId?: string
  dashboardRoutes?: Record<string, string>
  tariffPaymentUrl?: string
}

const runtimeConfig: TCrmRuntimeConfig = {}

export const setCrmRuntimeConfig = (config: TCrmRuntimeConfig) => {
  Object.assign(runtimeConfig, config)
}

export const getCrmCompanyId = () => {
  if (!runtimeConfig.companyId) {
    throw new Error('CRM company id is not defined')
  }

  return runtimeConfig.companyId
}

export const getCrmDashboardRoutes = () => runtimeConfig.dashboardRoutes ?? {}

export const getCrmTariffPaymentUrl = () => {
  if (!runtimeConfig.tariffPaymentUrl) {
    throw new Error('CRM tariff payment URL is not defined')
  }

  return runtimeConfig.tariffPaymentUrl
}
